import { get } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse } from "./types";

// 积分奖励相关API
export const pointApi = {
  /**
   * 获取任务列表/进度
   * @param game_id - 游戏ID
   * @param target_language - 语言
   * @returns Promise<ApiResponse>
   */
  getTasks: (
    game_id: number,
    target_language: string
  ): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.POINT_REWARD,
      API_CONFIG.ACTIONS.GET_TASKS,
      { game_id, target_language }
    );
    return get<ApiResponse>(url);
  },

  /**
   * 获取奖励列表（需要登录态）
   * @param game_id - 游戏ID
   * @param target_language - 语言
   * @returns Promise<ApiResponse>
   */
  getRewards: (
    game_id: number,
    target_language: string
  ): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.POINT_REWARD,
      API_CONFIG.ACTIONS.GET_REWARDS,
      { game_id, target_language }
    );
    return get<ApiResponse>(url);
  },

  /**
   * 兑换奖励（需要登录态）
   * @param game_id - 游戏ID
   * @param reward_id - 奖励ID
   * @param server_id - 服务器ID
   * @param role_id - 角色ID
   * @returns Promise<ApiResponse>
   */
  exchange: (
    game_id: number,
    reward_id: number,
    server_id: number,
    role_id: number
  ): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.POINT_REWARD,
      API_CONFIG.ACTIONS.EXCHANGE,
      { game_id, reward_id, server_id, role_id }
    );
    return get<ApiResponse>(url);
  },

  /**
   * 获取兑换记录（需要登录态）
   * @param game_id - 游戏ID
   * @param target_language - 语言
   * @returns Promise<ApiResponse>
   */
  getExchangeRecords: (
    game_id: number,
    target_language: string
  ): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.POINT_REWARD,
      API_CONFIG.ACTIONS.EXCHANGE_RECORDS,
      { game_id, target_language }
    );
    return get<ApiResponse>(url);
  },

  /**
   * 记录任务行为完成（需要登录态）
   * @param game_id - 游戏ID
   * @param task_id - 任务ID
   * @param action_type - 行为类型：1-点击任务, 2-浏览时长
   * @returns Promise<ApiResponse>
   */
  taskAction: (
    game_id: number,
    task_id: number,
    action_type: 1 | 2
  ): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.POINT_REWARD,
      API_CONFIG.ACTIONS.TASK_ACTION,
      { game_id, task_id, action_type }
    );
    return get<ApiResponse>(url);
  },
};
